/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svd_ModelInputs */

const en_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`model: custom scope & deployment · contact for quote`)
};

const ar_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النموذج: نطاق وتسليم مخصص · تواصل لعرض السعر`)
};

const bn_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাজের ধরন: কাস্টম স্কোপ ও ডিপ্লয়মেন্ট · কোটেশন জানতে যোগাযোগ করুন`)
};

const de_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modell: Benutzerdefinierter Umfang und Bereitstellung · Kontaktieren Sie uns für ein Angebot`)
};

const es_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modelo: alcance e implementación personalizados · contacto para cotización`)
};

const fr_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modèle : portée et déploiement personnalisés · contact pour devis`)
};

const pt_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modelo: escopo personalizado e implantação · contato para orçamento`)
};

const zh_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模型：自定义范围和部署 · 联系报价`)
};

const tr_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`modeli: özel kapsam ve dağıtım · fiyat teklifi için iletişime geçin`)
};

const ru_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`модель: кастомный скоуп и деплой · свяжитесь для расчёта`)
};

const pl_svd_model = /** @type {(inputs: Svd_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`model: niestandardowy zakres i wdrożenie · kontakt w sprawie wyceny`)
};

/**
* | output |
* | --- |
* | "model: custom scope & deployment · contact for quote" |
*
* @param {Svd_ModelInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_model = /** @type {((inputs?: Svd_ModelInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_ModelInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_model(inputs)
	if (locale === "bn") return bn_svd_model(inputs)
	if (locale === "de") return de_svd_model(inputs)
	if (locale === "es") return es_svd_model(inputs)
	if (locale === "fr") return fr_svd_model(inputs)
	if (locale === "pt") return pt_svd_model(inputs)
	if (locale === "zh") return zh_svd_model(inputs)
	if (locale === "tr") return tr_svd_model(inputs)
	if (locale === "ru") return ru_svd_model(inputs)
	if (locale === "pl") return pl_svd_model(inputs)
	return en_svd_model(inputs)
});